import React from 'react'
import { AccountHelp, Breadcrumb, CustomerHero, CustomerResources, Faq, OfferCards } from '../../components'
import { Container } from 'react-bootstrap'
import { images } from '../../utils/customFn'
import './customer.scss'
const Customer = () => {
    const crumbsdata = [
        { label: 'Sentry Insurance home', link: '/' },
        { label: 'Customers', link: '/customer' }
    ]
    const offerCardData = [
        {
            id: 1,
            imageUrl:
            images["dollar_signs.avif"],
            title: 'Make a payment',
            description:'If you know your account number and ZIP code, you can use Quick pay to pay your bill without signing in. If you have questions about your account, talk to your Sentry agent or give us a call at 800-473-6879.',
            linkUrl: '/quickpays',
            linkText: 'Make a payment',
        },
      {
            id: 2,
            imageUrl:
            images["calculator.avif"],
            title: 'Review claim status',
            description:'Quickly locate a claim and review its status without logging in to your account.',
            linkUrl: '/',
            linkText: 'File a claim',
        },
        {
            id: 3,
            imageUrl:
            images["claimStatus.avif"],
            title: 'Review claim status',
            description:'Quickly locate a claim and review its status without logging in to your account.',
            linkUrl: '/quickpays',
            linkText: 'Review claim statust',
        }, 

    ]
    const faqdata = [
        {
            id:1,
            eventKey:1,
            header:'How do you access your Sentry account?',
            body:'To access your Sentry customer account, click Log in in the top right corner of any screen on our website. From there, enter your username and password. You may be prompted to complete a quick two-step verification process—if so, just follow the prompts to finish signing in. If you have any questions, give us a call at 800-473-6879 and we’ll help you get to your account.'
        },
        {
            id:2,
            eventKey:2,
            header:'What do you need to have ready when filing a claim?',
            body:'To access your Sentry customer account, click Log in in the top right corner of any screen on our website. From there, enter your username and password. You may be prompted to complete a quick two-step verification process—if so, just follow the prompts to finish signing in. If you have any questions, give us a call at 800-473-6879 and we’ll help you get to your account.'
        },
        {
            id:3,
            eventKey:3,
            header:'Can Sentry help make your business safer?',
            body:'To access your Sentry customer account, click Log in in the top right corner of any screen on our website. From there, enter your username and password. You may be prompted to complete a quick two-step verification process—if so, just follow the prompts to finish signing in. If you have any questions, give us a call at 800-473-6879 and we’ll help you get to your account.'
        },
        {
            id:4,
            eventKey:4,
            header:'Does Sentry offer anything other than business insurance?',
            body:'To access your Sentry customer account, click Log in in the top right corner of any screen on our website. From there, enter your username and password. You may be prompted to complete a quick two-step verification process—if so, just follow the prompts to finish signing in. If you have any questions, give us a call at 800-473-6879 and we’ll help you get to your account.'
        },
    ]
    return (
        <div className='customer-wrapped'>
            <Container>
                <Breadcrumb crumbs={crumbsdata} />
                <CustomerHero />
                <OfferCards heading="" data={offerCardData} />
                <CustomerResources/>
                <Faq heading="Frequently asked questions" FaqData={faqdata}/>
                <AccountHelp/>
            </Container>
        </div>
    )
}

export default Customer
